// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4404":"1b5fe672","6115":"7840db1d","8384":"9e6f5c78"}[chunkId] + ".chunk.css";
};